<template>
    <div>
        <el-card>
            <el-alert title="技术文档" type="info" center show-icon :closable='false'> </el-alert>

            <div class="technical_container">
                <div class="technical_text">
                    <h3 v-if="isEdit">编辑技术文档</h3>
                    <h3 v-else>添加技术文档</h3>
                    <el-button size="mini" class="btn" @click="goTechnicalList">返回</el-button>
                </div>

                <el-form :model="technicalForm" label-width="90px" label-position="top" class="technical_form">
                    <el-form-item label="文件:">
                        <el-button v-if="downloadPath != '' && downloadPath != null" type="primary" size="mini" @click="delFile">删除</el-button>
                        <div class="file_box">
                            <div class="file_name" v-if="downloadPath != '' && downloadPath != null">{{ technicalForm.fileName }}</div>
                            <el-upload
                                v-else
                                action="string"
                                list-type="picture-card"
                                :http-request="uploadFile"
                                :limit="1"
                                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                :show-file-list="false">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="技术文档名称:" prop="docTitle">
                        <el-input v-model="technicalForm.docTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="技术文档描述:" prop="docDesc">
                        <el-input v-model="technicalForm.docDesc"></el-input>
                    </el-form-item>
                    <el-form-item class="btns">
                        <el-button v-if="!isEdit" type="primary" @click="addTechnical" :loading="isAdd">添加</el-button>
                        <el-button v-else type="primary" @click="addTechnical" :loading="isAdd">编辑</el-button>
                        <el-button @click="resetTechnicalForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { uploadFile, delFile, getTechnicalContent, addTechnical, updateTechnical } from '@/api/editTechnical'
export default {
  data () {
    return {
      technicalForm: {
        downloadPath: '',
        id: null,
        docDesc: '',
        docTitle: '',
        fileName: ''
      },
      // 添加按钮样式
      isAdd: false,
      // 判断编辑还是添加  默认添加
      isEdit: false,
      downloadPath: ''
    }
  },
  created () {
    if (this.$route.params.id != undefined) {
      // 编辑状态
      this.isEdit = true
      // 获取编辑的内容
      this.getTechnicalContent(this.$route.params.id)
      this.technicalForm.id = Number(this.$route.params.id)
    } else {
      this.isEdit = false
    }
  },
  methods: {
    // 上传技术文档文件
    uploadFile (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadFile(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.downloadPath = res.data.url
          this.technicalForm.fileName = res.data.fileName
        }
      })
    },
    // 删除技术文档文件
    delFile () {
      delFile(this.downloadPath).then(res => {
        if (res.code == '-1') {
          this.$message.error(res.msg)
        } else {
          this.downloadPath = ''
        }
      })
    },
    // 获取要修改的技术文档内容
    getTechnicalContent (id) {
      getTechnicalContent(id).then(res => {
        if (res.code == 0) {
          this.technicalForm.fileName = res.data.fileName
          this.technicalForm.docTitle = res.data.docTitle
          this.technicalForm.docDesc = res.data.docDesc
          this.downloadPath = res.data.downloadPath
        } else {
          this.$message.error('获取编辑的技术文档参数失败')
        }
      })
    },
    // 添加保存技术文档  编辑保存技术文档
    addTechnical () {
      this.isAdd = true
      if (this.downloadPath == '' || this.downloadPath == null) {
        this.$message.error('请上传技术文档文件！')
        this.isAdd = false
        return
      } else {
        this.technicalForm.downloadPath = this.downloadPath
      }
      if (this.technicalForm.docTitle == '' || this.technicalForm.docTitle == null) {
        this.$message.error('请输入技术文档名称！')
        this.isAdd = false
        return
      }
      // if(this.technicalForm.docDesc == '' || this.technicalForm.docDesc == null){
      //     this.$message.error("请输入技术文档描述！")
      //     this.isAdd = false
      //     return
      // }
      if (!this.isEdit) {
        // 添加保存技术文档
        addTechnical(this.technicalForm).then(res => {
          this.isAdd = false
          if (res.code == 0) {
            this.$message.success('添加成功！')
            this.resetTechnicalForm()
            this.$router.push(this.technicalListRoute())
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        // 编辑保存技术文档
        updateTechnical(this.technicalForm).then(res => {
          this.isAdd = false
          if (res.code == 0) {
            this.$message.success('编辑成功！')
            this.resetTechnicalForm()
            this.$router.push(this.technicalListRoute())
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 重置
    resetTechnicalForm () {
      this.technicalForm.docDesc = ''
      this.technicalForm.docTitle = ''
      this.technicalForm.downloadPath = ''
    },
    goTechnicalList () {
      this.$router.push(this.technicalListRoute())
      this.resetTechnicalForm()
      if (this.isEdit == false && this.downloadPath != '') {
        this.delFile()
      }
    },
    technicalListRoute () {
      return { name: 'admin-resources', query: { ...this.$route.query } }
    }
  }
}
</script>

<style lang="less" scoped>
.technical_container{
    margin-top: 20px;
    .technical_text{
        display: flex;
        justify-content: space-between;
        h3{
            border-bottom: 2px solid #409eff;
        }
        .btn{
            border: 0;
            color: #ccc;
            font-size: 15px;
        }
    }
}
.technical_form{
    margin-top: 20px;
    .btns{
        display: flex;
        justify-content: flex-end;
    }
    .file_name{
        font-size: 16px;
        color: #606266;
    }
}
</style>
